import { render } from "./Template.vue?vue&type=template&id=10dca244"
import script from "./Template.vue?vue&type=script&lang=js"
export * from "./Template.vue?vue&type=script&lang=js"

import "./Template.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script